export class Request {
  traceCode: string;
  tracePin: string;
  klantnaam: string;
}
